<style>
  /* 74% for Galaxy S8/9 */
  input {
      max-width:74%;
      outline:0
  }

  button {
    margin-top: -0.2rem;
    margin-bottom: 0;
  }

  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
  }
  .loading-bar {
    display: inline-block;
    width: 4px;
    height: 18px;
    border-radius: 4px;
    animation: loading 1s ease-in-out infinite;
  }
  .loading-bar:nth-child(1) {
    background-color: #3498db;
    animation-delay: 0;
  }
  .loading-bar:nth-child(2) {
    background-color: #c0392b;
    animation-delay: 0.09s;
  }
  .loading-bar:nth-child(3) {
    background-color: #f1c40f;
    animation-delay: .18s;
  }
  .loading-bar:nth-child(4) {
    background-color: #27ae60;
    animation-delay: .27s;
  }

  @keyframes loading {
    0% {
      transform: scale(1);
    }
    20% {
      transform: scale(1, 2.2);
    }
    40% {
      transform: scale(1);
    }
  }

  form {
    padding-bottom: 1.2em;
  }

  #recent-memes__memes {
    align-items: center;
  }

  h2 span {
    margin: 0 .3em;
    color: rgb(56, 132, 191);
  }
</style>

<script>
import { onMount } from 'svelte'
import SearchResults from './SearchResults.svelte'
import RecentMeme from './RecentMeme.svelte'
import elasticlunr from './elastic.js'

import { searchQuery, updateQueryString, updateUrlParams, searchResultSortOrder, searchResultPageNumber } from './urlParams.js'
import { pageTitle, placeholderText } from '../../siteInfo.js'
import { recentMemes } from './storage.js'
import { canShare } from './constants'

const search_index = {}
let timings
let index
let timingsLoaded = false
let indexLoaded = false
$: isLoading = (!(timingsLoaded && indexLoaded))

// trying out some url shenanigans
let searchTerm = ''
let output
loadSearchTerm()

function loadSearchTerm () {
  const initialSearchTerm = $searchQuery
  if (initialSearchTerm) {
    searchTerm = initialSearchTerm
  } else {
    searchTerm = ''
  }
}

function runSearch () {
  if (searchTerm !== '') {
    output = index.search(searchTerm, { expand: true })
  } else {
    output = undefined
  }
}

function getTimings () {
  fetch('/static/data/combined-timings.json')
    .then(async response => {
      if (response.ok) {
        timings = await response.json()
        timingsLoaded = true
      }
    })
    .catch(() => {
      timingsLoaded = true
    })
}

function getSearchIndex () {
  fetch('/static/data/search-index.json')
    .then(async response => {
      if (response.ok) {
        const files = await response.json()
        index = elasticlunr.Index.load(files)
        runSearch()
        indexLoaded = true
      }
    })
    .catch(() => {
      indexLoaded = true
    })
}

onMount(async () => {
  getSearchIndex()
  getTimings()
})

export const handleSubmit = function () {
  console.log('handleSubmit')
  runSearch()
  searchQuery.set(searchTerm)
  searchResultPageNumber.set(0)
  updateQueryString()
}

window.onpopstate = function (event) {
  updateUrlParams()
  loadSearchTerm()
  runSearch()
}

let thisSearchResultSortOrder = $searchResultSortOrder
function changeSortOrder () {
  if (!isLoading) {
    searchResultSortOrder.set(thisSearchResultSortOrder)
    // yeah, rerunning the entire search is a little heavy handed...
    handleSubmit()
  }
};

let expandRecents = (searchTerm === '')
let expandRecentsArrow = '▾'
$: expandRecentsArrow = expandRecents ? '▾' : '▸'
const shareOrDownload = canShare ? 'Share' : 'Download'
function expandOrCollapseRecents () {
  expandRecents = !expandRecents
}

function goHome () {
  history.pushState({}, '', '/')
  searchTerm = ''
  output = undefined
  expandRecents = true
}

let fontsLoaded = false
Promise.all([
  document.fonts.load("40px 'Anton'"),
  document.fonts.load("28px 'Roboto Condensed'")
]).then(() => {
  fontsLoaded = true
})
</script>

<h1><a href="/" on:click|preventDefault={goHome}>{pageTitle}</a></h1>
<form role="search" on:submit|preventDefault={handleSubmit}>
  
  <input type="text" name="q" placeholder="{placeholderText}" bind:value={searchTerm} autocomplete="off" autocorrect="off" autocapitalize="off" disabled="{isLoading}" aria-label="search" title="Search" tabindex="0">
  <button disabled="{isLoading}" type="submit">Search</button>

  <fieldset>
    <legend>Sort Order</legend>
    <input id="relevant" checked type='radio' bind:group={thisSearchResultSortOrder} name="sort-order" value="relevant" on:change={changeSortOrder}>
    <label for="relevant" class="checkable">Relevant</label>

    <input id="chronological" type='radio' bind:group={thisSearchResultSortOrder} name="sort-order" value="chronological" on:change={changeSortOrder}>
    <label for="chronological" class="checkable">Chronological</label>
  </fieldset>

</form>
<!-- 
<h2>
  ★ Your Favorited Memes:
</h2>
 -->
{#if fontsLoaded}
  {#if typeof(output) === "undefined"}
    {#if $recentMemes.length >= 1}
      <h2><span on:click|preventDefault={expandOrCollapseRecents}>{expandRecentsArrow}</span>Your Most Recent Memes:</h2>
    {/if}
    
    {#if (expandRecents && $recentMemes.length > 0)}
      <p>Click Image to {shareOrDownload}</p>
      <div class="flex one two-500 three-700 four-1000" id="recent-memes__memes">
        {#each $recentMemes as meme, i (meme.index + i)}
          <RecentMeme meme={meme}/>
        {/each}
      </div>
    {/if}
  {/if}
{/if}


{#if isLoading}
  <div class="loading">
    <div class="loading-bar"></div>
    <div class="loading-bar"></div>
    <div class="loading-bar"></div>
    <div class="loading-bar"></div>
  </div>
{:else if typeof(output) !== "undefined"}
  <SearchResults searchResults={output} timings={timings}/>
{/if}
